// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__25I2i","bigColWidth":"Table_bigColWidth__1IJA6","biggerColWidth":"Table_biggerColWidth__2r2Kq","row":"Table_row__3TpSx","col":"Table_col__1HJus"};